import { Modal, PDFRenderer } from "components";
import config from "config";
import { useAppLocation, useAppSearch } from "_graphql/cache/auth";

export default function ViewPaymentReceiptContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const { params } = useAppLocation();
  const searchParams = useAppSearch();

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      size="4xl"
      title="Payment Receipt"
      description="Details of payment receipt are shown below"
    >
      {/* {searchParams?.id} */}
      <PDFRenderer
        url={`${config.asset.uri}treaty_receivable_payment_receipt/${btoa(
          JSON.stringify({
            treaty_id: params?.treaty,
            treaty_payment_id: searchParams?.id || "",
          })
        )}`}
      />
    </Modal>
  );
}
